import { Application_Constraints } from '../api/typegen';

export const getConstraintsDefaultAmountValue = (
  constraints: Application_Constraints['GET']['Response'] | undefined,
) =>
  constraints?.amountInterval?.initialValue ||
  constraints?.amountInterval?.defaultValue;
